import { render, staticRenderFns } from "./ModalListChat.vue?vue&type=template&id=848ef12c"
import script from "./ModalListChat.vue?vue&type=script&lang=js"
export * from "./ModalListChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports